<template>
  <div class="w-100">
    <div class="mb-4">
      <h1 class="mb-4">Prestación asistencial a terceros</h1>
      <div class="section">
        <div class="col-md-6">
          <SelectSearch
            placeholder="Seleccionar Empleado"
            name="name"
            label="Empleado"
            :options="employess"
            :loading="loading"
            :disabled="false"
            :value="employee"
            @input="(value) => selectedEmployee(value)"
            @search="(value) => searchEmployee(value)"
          />
        </div>
      </div>
    </div>
    <div class="mb-4">
      <form @submit.prevent="save()">
        <div class="content-form-employee-2 mb-5">
          <div class="header">Registro - prestación asistencial a terceros</div>
          <p class="my-4">
            Formulario prestación asistencial a terceros - Datos personales
          </p>
          <div class="row mt-2">
            <div class="col-md-4 mb-5">
              <Input
                label="Tipo de evento"
                name="event_type"
                :value="formData.event_type"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.event_type = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Nombres"
                name="names"
                :value="formData.names"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.names = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Primer apellido"
                name="first_surname"
                :value="formData.first_surname"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.first_surname = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Segundo apellido"
                name="second_surname"
                :value="formData.second_surname"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.second_surname = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Edad"
                name="name"
                :value="formData.age"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.age = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Select
                label="Sexo"
                name="name"
                :options="genders"
                :value="formData.gender"
                :required="true"
                :disabled="false"
                v-model="formData.gender"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Select
                label="Tipo de documento"
                name="name"
                :options="[]"
                :value="formData.document_type"
                :required="true"
                :disabled="false"
                v-model="formData.document_type"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Número documento"
                name="document_number"
                :value="formData.document_number"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.document_number = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Télefono"
                name="phone"
                :value="formData.phone"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.phone = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Select
                label="Área"
                name="name"
                :options="areas"
                :value="formData.area_id"
                :required="true"
                :disabled="false"
                v-model="formData.area_id"
                @onSelect="loadPositions"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Select
                label="Cargo"
                name="name"
                :options="positions"
                :value="formData.position_id"
                :required="true"
                :disabled="false"
                v-model="formData.position_id"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Date
                label="Fecha de ingreso"
                name="admission_date"
                :value="formData.admission_date"
                :required="true"
                :disabled="false"
                v-model="formData.admission_date"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Empresa del contratista"
                name="contractor_company"
                :value="formData.contractor_company"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.contractor_company = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Nombre de contacto de su  SST de su empleador"
                name="sst_contact_name"
                :value="formData.sst_contact_name"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.sst_contact_name = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Telefono de contacto"
                name="contact_phone"
                :value="formData.contact_phone"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.contact_phone = event.target.value)"
              />
            </div>
            <div class="col-md-4 mb-5">
              <Input
                label="Correo electronico"
                name="email"
                :value="formData.email"
                :required="true"
                :disabled="false"
                @input="(event) => (formData.email = event.target.value)"
              />
            </div>
          </div>
          <div>
            <b-alert show variant="warning" class="alert-warning-message mb-5">
              <div class="d-flex align-items-center">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/alert-line.svg"
                    alt=""
                    width="28px"
                    height="28px"
                  />
                </div>
                <div>
                  <p style="color: #263238; font-size: 16px; margin-bottom: 0">
                    Por favor verifica la información antes de seguir con el
                    registro de accidente laboral.
                  </p>
                </div>
              </div>
            </b-alert>
          </div>
          <div class="d-flex justify-content-center mb-4">
            <button
              class="button_primary"
              type="submit"
              :disabled="isBusy || $v.$invalid"
            >
              <b-spinner v-if="isBusy" />
              Guardar y registrar evento
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { getEmployees } from "@/services/health-tracker/matrizIper/service";
import { getAreas } from "@/services/health-tracker/diagnostic/service";
import {
  getPositionByArea,
} from "@/services/health-tracker/matrizIper/service";
import SelectSearch from "../../../matrizIper/components/SelectSearch.vue";
const { required } = require("vuelidate/lib/validators");
import useInputs from "@/components/general/Inputs";
const { Input, Select, Date } = useInputs();
export default {
  name: "FormEmployee2",
  components: {
    SelectSearch,
    Input,
    Select,
    Date,
  },
  data() {
    return {
      employess: [],
      areas: [],
      positions: [],
      loading: false,
      search: "",
      abortController: null,
      abortControllerPosition: null,
      employee: null,
      formData: {
        event_type: "Tipo de evento",
        area_id: null,
        names: "",
        position_id: null,
        first_surname: "",
        second_surname: "", //Este campo es opcional
        admission_date: "",
        contractor_company: "",
        age: null,
        sst_contact_name: "",
        gender: "",
        contact_phone: "",
        document_type: "",
        email: "",
        document_number: "",
        phone: "", // Este campo es opcional
      },
      isBusy: false,
      genders: [
        {
          id: "M",
          name: "Masculino",
        },
        {
          id: "F",
          name: "Femenino",
        },
      ]
    };
  },
  validations: {
    formData: {
      name: {
        required,
      },
    },
  },
  methods: {
    async loadEmployess() {
      const me = this;
      me.loading = true;
      me.employess = [];
      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { result } = await getEmployees(
          {
            search: me.search,
          },
          signal
        );
        me.employess = result;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
    async loadAreas() {
      const me = this;
      me.areas = [];
      me.loadingArea = true;
      try {
        const { data } = await getAreas();
        me.areas = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingArea = false;
      }
    },
    async loadPositions() {
      const me = this;
      me.positions = [];
      me.loadingPosition = true;
      if (me.abortControllerPosition) {
        me.abortControllerPosition.abort(); // Cancela la petición anterior
      }

      me.abortControllerPosition = new AbortController();
      const signal = me.abortControllerPosition.signal;
      try {
        const { data } = await getPositionByArea(
          me.formData.area_id?.id,
          {
            q: "",
          },
          signal
        );
        me.positions = data?.data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingPosition = false;
      }
    },
    searchEmployee(value) {
      const me = this;
      me.search = value;
      me.loadEmployess();
    },
    save() {
      const me = this;
      console.log(me.formData);
    },
  },
  mounted() {
    const me = this;
    me.loadAreas();
  }
};
</script>

<style lang="css">
.content-form-employee-2 {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
  text-align: left !important;
}
.content-form-employee-2 .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
.download-template-pdf {
  border: none !important;
  background-color: transparent !important;
  color: #0056b3 !important;
  text-decoration: underline;
  padding: 0 !important;
}
</style>
